import service from "@irati/utils/tracking/index"
import {get} from "lodash"

const tracking = {}

tracking.cancelContinue = () => {
  service.trackRecognitionEvent("continue")
}

tracking.cancelConfirm = () => {
  service.trackRecognitionEvent("quit")
}

tracking.welcomeTutorial = (finished) => {
  if (finished) {
    service.trackRecognitionEvent("finished_tutorial")
  } else {
    service.trackRecognitionEvent("skipped_tutorial")
  }
}

tracking.commentPollAndRecognition = () => {
  service.trackRecognitionEvent("comment")
}

tracking.errorsComment = (response) => {
  const statusCode = get(response, "graphQLErrors[0].apiError.response.status", null)
  const data = {statusCode: `${statusCode}`}
  service.trackRecognitionEvent("comment_error", data)
}

export default tracking
